<app-form-group
    [dataItem]="dataItem"
    [userListBase]="userListBase"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)"
>
</app-form-group>

